import React, { Component } from "react";
import PropTypes from "prop-types";
import { load, update } from "actions/userProfileActions";
import { connect } from "react-redux";
import EditUserProfileForm from "./editUserProfile";
import moment from "moment";
import * as R from "ramda";
import { loadDependantFields } from "actions/dependantActions";
import { Button, Loader } from "cxa-components";
import RenderField from "cxa-components/field";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";
import Dependants from "./Dependants";
import LifeStage from "./LifeStage";
import { renderAsHTML } from "../../utils";
import StandardMoney from "../common/StandardMoney";

const renderOutput = ({ id, value }) => <div id={id}>{!R.isEmpty(value) ? value : "-"}</div>;

renderOutput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.any,
};

const formatValue = (value, field, intl) => {
  if (!value || !field) {
    return "";
  }
  switch (field.type) {
    case "Date":
      return moment(value).format();

    case "Decimal":
      return <StandardMoney value={value} />;
    case "Boolean":
      return value === "True"
        ? intl.formatMessage({ id: "Yes", defaultMessage: "Yes" })
        : intl.formatMessage({ id: "No", defaultMessage: "No" });
    case "String":
      return renderAsHTML("span", value)
    default: {
      let displayValue = value;
      if (field.id !== "FullName" && field.id !== "Identification" && field.id !== "BirthDate") {
        displayValue = intl.formatMessage({ id: value, defaultMessage: value });
      }
      return displayValue;
    }
  }
};

const getImageUrl = (lifeStage, data) => {
  switch (lifeStage) {
    case "Single": {
      const gender = data["Gender"];

      if (gender === "Male") {
        return "/assets/images/common/SingleMale.png";
      }

      return "/assets/images/common/SingleFemale.png";
    }

    case "Couple":
      return "/assets/images/common/couple.png";

    case "YoungFamily":
      return "/assets/images/common/YoungFamily.png";

    case "MatureFamily":
      return "/assets/images/common/mature_family.png";

    case "PreRetirement":
      return "/assets/images/common/near_retirement.png";

    case "UNKNOWN":
      return "";

    default:
      return "";
  }
};

class Profile extends Component {
  constructor() {
    super();

    this.showEditPage = this.showEditPage.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.submitEmployee = this.submitEmployee.bind(this);

    this.state = {
      editEmployee: false,
    };
  }

  componentDidMount() {
    this.props.load();
    this.props.loadDependantFields();
  }

  showEditPage() {
    this.setState({ editEmployee: true });
  }

  cancelEdit() {
    this.setState({ editEmployee: false });
  }

  submitEmployee(values, employeeKey, update, cancel) {
    update(values, employeeKey);
    cancel();
  }

  render() {
    const { employee, lifeStage, myProfileNote, shouldDisplayDependant } = this.props.user;
    const { error, isCreationAllowed, fetching } = this.props;
    const intl = this.props.intl;
    const trimProfileNote = myProfileNote && myProfileNote.replace("<b>Note:</b>", "").trim();
    const profileNoteForDisplay = trimProfileNote
      ? intl.formatMessage({
          id: trimProfileNote,
          defaultMessage: myProfileNote,
        })
      : `${intl.formatMessage(messages.noteDescription)} ${intl.formatMessage(
          messages.noteContentDescription
        )}`;

    if (fetching) {
      return <Loader />;
    }

    if (!employee) {
      return null;
    }

    const dependantListDTO = R.propOr({}, "dependantListDTO")(this.props.user);
    const initialValues = employee.data;

    if (!employee) {
      return null;
    }
    let isEmployeeEditable = false;
    employee.fields.forEach(field => {
      if (!field.disabled) {
        isEmployeeEditable = true;
      }
    });

    const employeeDataReadOnly = (
      <div>
        <article className="card">
          <section>
            {employee.fields.map(field => {
              let value = formatValue(employee.data[field.id], field, intl);
              if (typeof value == "string") {
                value = renderAsHTML("span", value);
              }

              return (
                <RenderField
                  id={field.id}
                  key={field.id}
                  label={intl.formatMessage({
                    id: field.displayName,
                    defaultMessage: field.displayName,
                  })}
                  value={value}
                  field={renderOutput}
                />
              );
            })}
          </section>
        </article>
        {isEmployeeEditable && (
          <Button primary type="button" onClick={this.showEditPage}>
            {intl.formatMessage(messages.editDescription)}
          </Button>
        )}
      </div>
    );

    const employeeDataEditable = (
      <EditUserProfileForm
        onSubmit={this.submitEmployee}
        fields={employee.fields}
        initialValues={initialValues}
        cancel={this.cancelEdit}
        error={error}
        employeeKey={employee.employeeKey}
        {...this.props}
      />
    );

    return (
      <div>
        <section>
          <h2>{intl.formatMessage(messages.myProfileDescription)}</h2>
          <div className="grid__wrapper">
            <div className="grid__item grid__item--six">
              {this.state.editEmployee ? employeeDataEditable : employeeDataReadOnly}
            </div>
          </div>
        </section>
        {lifeStage && lifeStage.display && (
          <LifeStage
            intl={intl}
            lifeStage={lifeStage}
            getImageUrl={getImageUrl}
            employee={employee}
          />
        )}
        {shouldDisplayDependant && (
          <Dependants
            intl={intl}
            dependantListDTO={dependantListDTO}
            isCreationAllowed={isCreationAllowed}
            profileNoteForDisplay={profileNoteForDisplay}
            formatValue={formatValue}
          />
        )}
      </div>
    );
  }
}

Profile.propTypes = {
  load: PropTypes.func,
  error: PropTypes.object,
  user: PropTypes.object,
  update: PropTypes.func,
  loadDependantFields: PropTypes.func,
  isCreationAllowed: PropTypes.bool,
  intl: intlShape.isRequired,
  fetching: PropTypes.bool,
};

const mapStateToProps = ({
  userProfile: { user, fetching, fetched, error, isCreationAllowed },
}) => ({
  user,
  fetching,
  fetched,
  error,
  isCreationAllowed,
});

const mapDispatchToProps = { load, update, loadDependantFields };

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Profile));



// WEBPACK FOOTER //
// ./components/employee/UserProfileContainer.js